import styled from 'styled-components/macro';
import { Row } from '@yme/atoms/grid';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const ProductCardWrapperStyled = styled(FlexWrapper) `
  width: auto;
`;
export const ProductCardStyled = styled(FlexWrapper) `
  height: auto;
  min-height: 124px;
  flex: 0 0 calc(33.33% - (48px / 3));

  transition: height 1.3s ease-in-out, min-height 0.5s ease-in-out;

  ${ADAPTIVE.maxWidth.tablet} {
    flex: 0 0 calc(50% - 12px);
  }

  ${ADAPTIVE.maxWidth.mobile} {
    flex: 0 0 100%;
  }
`;
export const HeaderStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  align-content: center;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const HeaderRowStyled = styled(Row) `
  margin-bottom: ${INDENT.sm};
  margin-top: ${INDENT.sm};

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: ${INDENT.xl};
    margin-top: ${INDENT.xl};
  }
`;
export const CounterSectionStyled = styled(RegularTextLevel3) `
  text-align: right;
  ${ADAPTIVE.maxWidth.mobile} {
    text-align: left;
  }
`;
